'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSelectors = normalizeSelectors;
function normalizeSelectors(selectors) {
  var normalizedSelectors = {
    success: {},
    error: {}
  };

  if (selectors !== undefined && selectors !== null) {
    if (selectors.success !== undefined && selectors.success !== null) {
      normalizedSelectors.success = selectors.success;
    } else {
      normalizedSelectors.success = selectors;
    }

    if (selectors.error !== undefined && selectors.error !== null) {
      normalizedSelectors.error = selectors.error;
    }
  }

  return normalizedSelectors;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/selectorUtils.js
// module id = 468
// module chunks = 0